// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"126":"results-restored","575":"results"}[chunkId] || chunkId) + "." + {"126":"eb6fe694","331":"f4f9ff8c","575":"cb8953af"}[chunkId] + ".chunk.js";
};